import api from "../index";

export const GetTutorialTypeApi = () => api.get('dropdown/gettutorialtype');
export const GetAllTutorialApi = (params) => api.get(`tutorialmaster/get-all?${params}`);
export const AddTutorialApi = (data, apiHeader) => api.post('tutorialmaster/add-update', data, apiHeader);
export const UpdateTutorialStatusApi = (data) => api.put('tutorialmaster/active-inactive', data);
export const DeleteTutorialApi = (tutorialId) => api.delete(`tutorialmaster/delete/${tutorialId}`);